import { Asset } from './asset';
import { EFingerpintTitle, Fingerprint, FingerprintPublicMetadata } from './fingerprint';
import { Item } from './item';
import { RemoteFile } from './remote-file';
import { User } from './user';

export enum EStatusFilter {
  PROTECTED = 'protected',
  UNABLE_TO_PROTECT = 'unableToProtect',
  VERIFIED = 'verified',
  UNABLE_TO_VERIFY = 'unableToVerify',
  NOT_VERIFIED = 'notVerified',
  REGISTRED = 'registred',
  UNABLE_TO_REGISTER = 'unableToRegister',
  IDENTIFIED = 'identified',
  UNABLE_TO_IDENTIFY = 'unableToIdentify',
  NOT_IDENTIFIED = 'notIdentified',
}

export enum EJobStatus {
  OPEN = 'OPEN',
  RUNNING = 'RUNNING',
  DONE = 'DONE',
  ERROR = 'ERROR',
}

export enum EJobResultCode {
  OK = 0,
  NOT_VERIFIED = 1,
  ERROR_BE = 2,
  ERROR_CONNECTION = 3,
  ERROR_QUALITY = 4,
  ERROR_BLURRY = 5,
  ERROR_AREA = 6,
  ERROR_OVERLAP = 7,
}

export enum EJobResultType {
  OK,
  FAILED,
  NOT_VERIFIED,
}

export enum EJobTitle {
  PROTECTION = 'protection',
  VERIFICATION = 'verification',
  VISUALISATION = 'visualisation',
  REGISTRATION = 'registration',
  IDENTIFICATION = 'identification',
}

export enum FlagType {
  Correct = 'correct',
  Incorrect = 'incorrect',
  Neutral = 'neutral',
}

export interface JobResult {
  code: EJobResultCode | number;
  message: number;
}

export interface JobMetadata {
  vertical?: string;
  blurDebugJson?: string;
  blurDetectionFlag?: string | number;
  verificationId?: string;
  verificationTaskId?: string;
  skuId?: string;

  visualisationJob?: Job;
  [key: string]: any;
}

export interface Job {
  id: string;
  title: EJobTitle;
  status: EJobStatus;
  tenantId: string;
  item: Item;
  startedAt: Date;
  finishedAt?: Date;
  resultMessage?: string;
  resultCode?: EJobResultCode;
  time?: number;
  publicMetadata?: JobMetadata;
  user: User;
  flag?: FlagType;
  flaggedAt?: Date;
  feedback?: string;
}

export interface IdentificationCandidate {
  itemId: string;
  confidence: number;
}

export interface TaskMetadata {
  fingerprintTitle?: EFingerpintTitle | string;
  fingerprintPublicMetadata?: {
    location?: {
      x: number;
      y: number;
      width: number;
      height: number;
    };
  };
  verificationId?: string;
  blurDetectionFlag?: string | number;
  candidates?: IdentificationCandidate[];

  [key: string]: any;
}

export interface Task {
  id: string;
  workerId: string;
  taskName: EJobTitle;
  workerQueue: string;
  status: EJobStatus;
  resultMessage: string;
  resultCode: EJobResultCode;
  publicMetadata: TaskMetadata;
  fingerprint?: Fingerprint;
  time?: number;
  file?: RemoteFile;
  assets?: Asset[];
}

export interface CreateJobData {
  title: EJobTitle;
  tenantId: string;
  itemId: string;
  verticalId?: string;
  jobPublicMetadata?: JobMetadata;
}

export interface CreateTaskData {
  fileId: string;
  publicMetadata?: any;
  fingerprintId?: string;
  verticalId?: string;
  debug?: string;
}

export interface CreateProtectionJobData {
  tenantId: string;
  itemId: string;
  fileId: string;
  verticalId?: string;
  jobPublicMetadata?: JobMetadata;
  fingerprintPublicMetadata?: FingerprintPublicMetadata;
}
